// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"48679838","839":"b1023cc2"}[chunkId] + ".chunk.js";
};